const LAURIER_BLUE = "#232ED1";
const LAURIER_GOLD = "#F4D35E";
const LAURIER_POWDER_BLUE_ONE = "#8EA8C3";
const LAURIER_POWDER_BLUE_TWO = "#B4C5E4";

const ACCENT_GREEN = "#28CE7B";
const ACCENT_RED = "#FF0000";
const WARNING = "#FE891E";
const DISABLED = "#EAEAEA";
const BACKGROUND_COLOR = "#F4F4F4";
const TEXT_COLOR = "#4A4A4A";

const BEIGE = "#fdf8f3";
const GREY = "#7d7d7d";

const OUILIVE_BLUE_HOVER = "rgba(81,107,232,0.8)";
const OUILIVE_BLUE_ACTIVE = "#3857EF";
const BLUE_CONTRAST_COLOR = "#FFFFFF";
const RED_CONTRAST_COLOR = "#FFFFFF";

export type ColorHex = `#${string}`;
export type ColorRGBA = `rgba(${string})`;

export type ColorsSystem = {
  blue: ColorHex;
  gold: ColorHex;
  powderBlueOne: ColorHex;
  powderBlueTwo: ColorHex;
  textRegularColor: ColorHex;
  mainBackground: ColorHex;
  white: ColorHex;
  black: ColorHex;
  lightGrey: ColorHex;
  mediumGrey: ColorHex;
  darkGrey: ColorHex;
  backgroundGrey: ColorHex;
  green: ColorHex;
  red: ColorHex;
  orange: ColorHex;
  disabled: ColorHex;
  beige: ColorHex;
  grey: ColorHex;
  secondaryContrast: ColorHex;
  primary_hover: ColorRGBA;
  primary_active: ColorHex;
  primaryContrast: ColorHex;
};

export const ColorsSystem: ColorsSystem = {
  blue: LAURIER_BLUE,
  gold: LAURIER_GOLD,
  powderBlueOne: LAURIER_POWDER_BLUE_ONE,
  powderBlueTwo: LAURIER_POWDER_BLUE_TWO,
  textRegularColor: TEXT_COLOR,
  mainBackground: BACKGROUND_COLOR,
  beige: BEIGE,
  grey: GREY,
  white: "#FFFFFF",
  black: "#050609",
  // black: "#191919",
  lightGrey: "#C5C5C5",
  mediumGrey: "#878787",
  darkGrey: TEXT_COLOR,
  backgroundGrey: "#EDEDED",
  green: ACCENT_GREEN,
  red: ACCENT_RED,
  orange: WARNING,
  disabled: DISABLED,
  // black: "#030304",
  primary_hover: OUILIVE_BLUE_HOVER,
  primary_active: OUILIVE_BLUE_ACTIVE,
  primaryContrast: BLUE_CONTRAST_COLOR,
  secondaryContrast: RED_CONTRAST_COLOR,
} as const;
